import { render, staticRenderFns } from "./Fibu.vue?vue&type=template&id=81b28672&"
import script from "./Fibu.vue?vue&type=script&lang=js&"
export * from "./Fibu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports